import { render } from "./FaceBlock.vue?vue&type=template&id=5ad90406"
import script from "./FaceBlock.vue?vue&type=script&lang=js"
export * from "./FaceBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__